import { render, staticRenderFns } from "./summary-customer-detail.vue?vue&type=template&id=f5e197fe"
import script from "./summary-customer-detail.vue?vue&type=script&lang=js"
export * from "./summary-customer-detail.vue?vue&type=script&lang=js"
import style0 from "./summary-customer-detail.vue?vue&type=style&index=0&id=f5e197fe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports